import type { components } from '../api/active/generated/openapi';

/** Signed URLs do not participate in these generated business versions. */
export type CatalogReadIndexItem =
  components['schemas']['CatalogReadIndexItem'];
export type CatalogReadIndex = components['schemas']['CatalogReadIndex'];

export function validateCatalogReadIndex(
  value: CatalogReadIndex,
): CatalogReadIndex {
  if (
    !value ||
    typeof value.version !== 'string' ||
    !value.version ||
    typeof value.authorizationVersion !== 'string' ||
    !value.authorizationVersion ||
    !Array.isArray(value.items)
  )
    throw new Error('目录索引版本缺失');
  const ids = new Set<string>();
  for (const item of value.items) {
    if (
      !item ||
      typeof item.id !== 'string' ||
      !item.id ||
      ids.has(item.id) ||
      (item.currentRevisionId !== null &&
        (typeof item.currentRevisionId !== 'string' ||
          !item.currentRevisionId)) ||
      typeof item.resourceVersion !== 'string' ||
      !item.resourceVersion ||
      typeof item.representationVersion !== 'string' ||
      !item.representationVersion ||
      (item.status !== undefined &&
        item.status !== 'active' &&
        item.status !== 'inactive') ||
      (item.sortOrder !== undefined && !Number.isSafeInteger(item.sortOrder))
    )
      throw new Error('目录索引成员缺失或重复');
    ids.add(item.id);
  }
  return value;
}
